module.exports = __webpack_public_path__ + "img/pulverização turbina 2.cc9c2110.webp";